import { Prompt } from 'react-router-dom';

export default function IsDirtyPrompt({ isDirty }) {
  return <Prompt when={isDirty} message="You have unsaved changes. Are you sure you want to leave?" />;
}
